<script>
   /**************************************************************/
   /* Svelte component for ScoresPlot settings                   */
   /**************************************************************/

   import { Container, CompSelector } from '../controls';

   export let params;
   export let pvoptions;
   export let model;
   export let res;

   let ncomp = 1;

   $: params = {
      'ncomp': ncomp,
   }
</script>

<Container label="">
<p class="title">Predictions</p>
</Container>

{#if model && res && pvoptions}
<CompSelector bind:value={ncomp} label='# LVs' maxNComp={pvoptions.ncompSel} />
{/if}

